import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivedraftComponent } from './activedraft/activedraft.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CountdownModule } from 'ngx-countdown';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    CountdownModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    ActivedraftComponent
  ],
  exports: [
    ActivedraftComponent
  ]
})
export class SharedModule { }
